import { useState } from "react";
import { toast } from "sonner";
import client, { formatApiErrorDetail } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Newsletter({ source = "site", heading = "JOIN OUR YAZA LIST", subtext, variant = "default" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await client.post("/subscribe", { email, source });
      toast.success(data.message || "You're on the list.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid={`newsletter-${source}`}>
      {heading && (
        <h3 className="font-display text-4xl md:text-6xl leading-none">{heading}</h3>
      )}
      {subtext && <p className="mt-4 max-w-md text-yaza-dim">{subtext}</p>}
      <form onSubmit={submit} className="mt-6 flex max-w-lg items-stretch border-b border-white/30 focus-within:border-yaza-accent transition-colors">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          data-testid="newsletter-email-input"
          className="w-full bg-transparent py-3 text-base outline-none placeholder:text-neutral-600"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit"
          className="flex items-center gap-2 whitespace-nowrap px-2 text-xs font-semibold uppercase tracking-widest text-yaza-accent transition-transform hover:translate-x-1 disabled:opacity-50"
        >
          {loading ? "..." : "Sign up"} <ArrowRight size={16} />
        </button>
      </form>
    </div>
  );
}
